import React from 'react';
import { Navigate } from 'react-router-dom';

interface RouteAuthentifieeProps {
  children: React.ReactNode;
}

const RouteAuthentifiee = ({ children }: RouteAuthentifieeProps) => {
  const accessToken = localStorage.getItem('accessToken');

  if (!accessToken) {
    return <Navigate to="/acces-refuse-connexion" replace state={{ depuis: window.location.pathname }} />;
  }

  return children;
};

export default RouteAuthentifiee;